import { render, staticRenderFns } from "./ActUploads__photo.vue?vue&type=template&id=3104ca5d&scoped=true&"
import script from "./ActUploads__photo.vue?vue&type=script&lang=js&"
export * from "./ActUploads__photo.vue?vue&type=script&lang=js&"
import style0 from "./ActUploads__photo.vue?vue&type=style&index=0&id=3104ca5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3104ca5d",
  null
  
)

export default component.exports